/* SYMH ticker tape (2026-09-30, Rich: "a news ticker tape ... with the weather
   in the customer's area"). The Liquid snippet renders the items and the
   customer's city; this fills the weather item from Open-Meteo (free, no key,
   two small requests: geocode the city, then today's forecast), adds the
   wishlist count, and doubles the tape so the scroll loops without a seam.
   Weather is cached 30 minutes per city in localStorage. Anything that
   fails just leaves that item out — the tape never shows an error. */
(function () {
  'use strict';
  // Loaded site-wide from layout/theme.liquid and, historically, by the
  // Mission Control section — running twice would clone the tape twice.
  if (window.__symhTickerLoaded) return;
  window.__symhTickerLoaded = true;
  var WMO = { 0: ['Clear', '☀'], 1: ['Mostly clear', '🌤'], 2: ['Partly cloudy', '⛅'], 3: ['Cloudy', '☁'],
    45: ['Fog', '🌫'], 48: ['Fog', '🌫'], 51: ['Drizzle', '🌦'], 53: ['Drizzle', '🌦'], 55: ['Drizzle', '🌦'],
    56: ['Freezing drizzle', '🌧'], 57: ['Freezing drizzle', '🌧'], 61: ['Rain', '🌧'], 63: ['Rain', '🌧'], 65: ['Heavy rain', '🌧'],
    66: ['Freezing rain', '🌧'], 67: ['Freezing rain', '🌧'], 71: ['Snow', '🌨'], 73: ['Snow', '🌨'], 75: ['Heavy snow', '🌨'],
    77: ['Snow grains', '🌨'], 80: ['Showers', '🌦'], 81: ['Showers', '🌦'], 82: ['Heavy showers', '⛈'],
    85: ['Snow showers', '🌨'], 86: ['Snow showers', '🌨'], 95: ['Thunderstorms', '⛈'], 96: ['Thunderstorms', '⛈'], 99: ['Thunderstorms', '⛈'] };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function cacheGet(k) { try { var v = JSON.parse(localStorage.getItem(k) || 'null'); if (v && Date.now() - v.t < 30 * 60 * 1000) return v.d; } catch (e) {} return null; }
  function cacheSet(k, d) { try { localStorage.setItem(k, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }
  function getJSON(url) { return fetch(url, { mode: 'cors' }).then(function (r) { return r.ok ? r.json() : null; }); }

  function geocode(city, region, country) {
    return getJSON('https://geocoding-api.open-meteo.com/v1/search?name=' + encodeURIComponent(city) + '&count=10&language=en&format=json')
      .then(function (d) {
        var rs = (d && d.results) || [];
        var cc = (country || '').toUpperCase(), rg = (region || '').toLowerCase();
        var pick = null;
        for (var i = 0; i < rs.length; i++) {
          var r = rs[i];
          if (cc && String(r.country_code).toUpperCase() !== cc) continue;
          if (rg && String(r.admin1 || '').toLowerCase() === rg) { pick = r; break; }
          if (!pick) pick = r;
        }
        return pick || rs[0] || null;
      });
  }
  function forecast(lat, lon) {
    return getJSON('https://api.open-meteo.com/v1/forecast?latitude=' + lat + '&longitude=' + lon +
      '&current=temperature_2m,weather_code&daily=temperature_2m_max,temperature_2m_min,precipitation_probability_max' +
      '&temperature_unit=fahrenheit&timezone=auto&forecast_days=1')
      .then(function (d) {
        if (!d || !d.current) return null;
        var code = d.current.weather_code, w = WMO[code] || ['', ''];
        var day = d.daily || {};
        return { temp: d.current.temperature_2m, word: w[0], icon: w[1],
                 hi: day.temperature_2m_max && day.temperature_2m_max[0], lo: day.temperature_2m_min && day.temperature_2m_min[0],
                 rain: day.precipitation_probability_max && day.precipitation_probability_max[0] };
      });
  }
  function weatherHtml(city, w) {
    var s = '<b>' + esc(Math.round(w.temp)) + '°F</b> ' + (w.icon ? '<i>' + esc(w.icon) + '</i> ' : '') + esc(w.word) + ' in ' + esc(city);
    if (w.hi != null && w.lo != null) s += ' · high ' + esc(Math.round(w.hi)) + '° / low ' + esc(Math.round(w.lo)) + '°';
    if (w.rain != null && w.rain >= 40) s += ' · ' + esc(w.rain) + '% chance of rain';
    return s;
  }
  function setWeather(ticker, html) {
    var els = ticker.querySelectorAll('[data-ticker-weather]');
    for (var i = 0; i < els.length; i++) { if (html) els[i].innerHTML = html; else els[i].parentNode.removeChild(els[i]); }
  }
  function loop(ticker) {
    var track = ticker.querySelector('[data-ticker-track]');
    if (!track || track.dataset.looped) return;
    track.dataset.looped = '1';
    var clone = document.createElement('span');
    clone.className = 'symh-ticker__clone';
    clone.setAttribute('aria-hidden', 'true');
    clone.innerHTML = track.innerHTML;
    track.appendChild(clone);
    // ~28px per second, never faster than 40s a lap (Rich: "slow it down")
    var w = track.scrollWidth / 2;
    ticker.style.setProperty('--ticker-dur', Math.max(40, Math.round(w / 28)) + 's');
  }
  function addItem(ticker, html, cls) {
    var track = ticker.querySelector('[data-ticker-track]');
    if (!track) return;
    var s = document.createElement('span'); s.className = 'symh-ticker__item' + (cls ? ' ' + cls : ''); s.innerHTML = html;
    track.appendChild(s);
  }
  // The wishlist count on the tape starts from the browser copy (first
  // paint) and is corrected by Mission Control with the account's real
  // count once the dashboard has loaded (2026-09-30: a heart on a deleted
  // product said "1 on your wishlist" beside an empty rail).
  function retime(ticker) {
    var track = ticker.querySelector('[data-ticker-track]');
    if (!track) return;
    var w = track.scrollWidth / 2;
    ticker.style.setProperty('--ticker-dur', Math.max(40, Math.round(w / 28)) + 's');
  }
  function setWishlist(n) {
    var tickers = document.querySelectorAll('[data-ticker]');
    for (var i = 0; i < tickers.length; i++) {
      var t = tickers[i], els = t.querySelectorAll('.symh-ticker__wl');
      var html = n ? '<a href="/pages/wishlist">' + esc(n) + ' on your wishlist</a>' : '';
      if (els.length) {
        for (var k = 0; k < els.length; k++) {
          if (html) els[k].innerHTML = html; else els[k].parentNode.removeChild(els[k]);
        }
      } else if (html) {
        // not on the tape yet (the browser copy was empty): add it to the
        // original run AND the looped copy so the seam stays invisible
        var track = t.querySelector('[data-ticker-track]');
        if (!track) continue;
        var s = document.createElement('span'); s.className = 'symh-ticker__item symh-ticker__wl'; s.innerHTML = html;
        var clone = track.querySelector('.symh-ticker__clone');
        if (clone) { track.insertBefore(s, clone); clone.appendChild(s.cloneNode(true)); }
        else track.appendChild(s);
      }
      retime(t);
    }
  }
  window.SYMH_TICKER = { setWishlist: setWishlist };
  // Friendly greeting by the customer's own clock (Rich, 2026-09-30).
  function greeting(name) {
    var h = new Date().getHours();
    var g = h < 5 ? 'Late night' : h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : h < 22 ? 'Good evening' : 'Late night';
    return g + (name ? ', ' + esc(name) : '') + (h < 5 || h >= 22 ? ' \u2014 we\u2019re here whenever you are' : '');
  }
  // ── header chip: local time + weather beside the cart (2026-09-30) ──
  function clockText() {
    try { return new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }); }
    catch (e) { var d = new Date(); return d.getHours() + ':' + ('0' + d.getMinutes()).slice(-2); }
  }
  function initHeaderWx() {
    var chips = document.querySelectorAll('[data-hdr-wx]');
    if (!chips.length) return;
    function tick() {
      var t = clockText();
      for (var i = 0; i < chips.length; i++) { var el = chips[i].querySelector('[data-hdr-time]'); if (el) el.textContent = t; }
    }
    tick(); setInterval(tick, 15000);
    for (var i = 0; i < chips.length; i++) (function (c) {
      var w = c.querySelector('[data-hdr-weather]'), city = c.dataset.city || '';
      if (!w || !city) { if (w) w.textContent = ''; return; }
      var key = 'symh_wx:' + city + '|' + (c.dataset.region || '') + '|' + (c.dataset.country || '');
      function show(x) {
        w.innerHTML = '<b>' + esc(Math.round(x.temp)) + '°F</b>' + (x.icon ? ' <i>' + esc(x.icon) + '</i>' : '');
        c.title = (x.word ? x.word + ' in ' : '') + city + (x.hi != null ? ' · high ' + Math.round(x.hi) + '° / low ' + Math.round(x.lo) + '°' : '');
      }
      var cached = cacheGet(key);
      if (cached) { show(cached); return; }
      geocode(city, c.dataset.region, c.dataset.country)
        .then(function (g) { return g ? forecast(g.latitude, g.longitude) : null; })
        .then(function (x) { if (x) { cacheSet(key, x); show(x); } else { w.textContent = ''; } })
        .catch(function () { w.textContent = ''; });
    })(chips[i]);
  }
  function init() {
    initHeaderWx();
    var tickers = document.querySelectorAll('[data-ticker]');
    for (var i = 0; i < tickers.length; i++) (function (t) {
      var hi = t.querySelector('[data-ticker-greeting]');
      if (hi) hi.innerHTML = greeting(t.dataset.name || '');
      try {
        var n = JSON.parse(localStorage.getItem('symh_wishlist') || '[]').length;
        if (n) addItem(t, '<a href="/pages/wishlist">' + n + ' on your wishlist</a>', 'symh-ticker__wl');
      } catch (e) {}
      var city = t.dataset.city || '';
      if (!city) { setWeather(t, null); loop(t); return; }
      var key = 'symh_wx:' + city + '|' + (t.dataset.region || '') + '|' + (t.dataset.country || '');
      var cached = cacheGet(key);
      if (cached) { setWeather(t, weatherHtml(city, cached)); loop(t); return; }
      loop(t);
      geocode(city, t.dataset.region, t.dataset.country)
        .then(function (g) { return g ? forecast(g.latitude, g.longitude) : null; })
        .then(function (w) { if (!w) { setWeather(t, null); return; } cacheSet(key, w); setWeather(t, weatherHtml(city, w)); })
        .catch(function () { setWeather(t, null); });
    })(tickers[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
